<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-4" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              {{ $t('Paieška') }}
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <div class="dataContainer">
              <v-row class="mb-3">
                <v-col cols="12" md="4">
                  <el-text-field
                    :label="$t('Pranešimo numeris')"
                    v-model="extraData.zus_numeris"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <el-date-picker
                    :label="$t('Pranešimo data nuo')"
                    v-model="extraData.pranesimo_data_nuo"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <el-date-picker
                    :label="$t('Pranešimo data nuo')"
                    v-model="extraData.pranesimo_data_iki"
                  />
                </v-col>
                <v-col cols="12" md="8">
                  <el-autocomplete
                    :items="filteredPranesimasRusys"
                    itemvalue="value"
                    itemtext="text"
                    :label="$t('Gauto pranešimo rūšis')"
                    multiple
                    v-model="extraData.dokumento_rusis_kla_id"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <el-text-field
                    :label="$t('Prašymo numeris')"
                    v-model="extraData.pra_id"
                  />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12">
                  <el-button
                    :loading="loading"
                    primary
                    @click.native.stop="searchData()"
                  >
                    {{ $t('Ieškoti') }}
                  </el-button>
                  <el-button :loading="loading" @click.native="clearData()">
                    {{ $t('Išvalyti') }}
                  </el-button>
                </v-col>
              </v-row>
            </div>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NtrPranesimaiSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {},
    pranesimas_rusys: [],
  }),
  computed: {
    ...mapGetters(['searchParams', 'savitarnaXid']),
    isExpanded() {
      return this.searchPanel === 0
    },
    filteredPranesimasRusys() {
      return this.pranesimas_rusys.map(item => {
        return item
      })
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['prasymas_zus_tipas'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pranesimas_rusys = res.data.list.prasymas_zus_tipas

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name &&
            this.searchParams.xid === this.savitarnaXid
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.checkGautasPranesimas()

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        xid: this.savitarnaXid,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
      }
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      //
    },
    checkGautasPranesimas() {
      const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')
      if (gautasPranesimas && gautasPranesimas.length > 0) {
        this.extraData.zus_numeris = gautasPranesimas
        this.searchPanel = 0
      }
      sessionStorage.setItem('gautasPranesimas', '')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
